import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentRelayCommand on RelayCommand {
    operation
    payload
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentRelayCommandFragment,
  ents.core.relay.Command
>({
  operation: graphql.transformers.OUT.validate(
    PASS_THROUGH,
    ents.core.relay.Command.Operation.assertIsOperation,
    { warnOnly: true },
  ),
  payload: PASS_THROUGH,
})
